import ParentCategoriesList from './ParentCategoriesList'

export default ParentCategoriesList
